

export const myAssessments = [
  {
    id: "math-term-01",
    name: "Mathematics Term Evaluation",
    time: "45 min",
    status: "Published",
    createdAt: "2026-04-12",
    questions: 32,
    owner: "My Assessment",
    grade: "Grade 01",
    language: "English",
    subject: "Subject I",
    term: "Term 1",
    author: "Admin",
    chapter: "Chapter 1",
    difficulty: "Medium",
    examCategory: "Model Exam",
    source: "Internal",
    createdBy: "Teacher",
    year: "2026",
  },
  {
    id: "science-unit-04",
    name: "Science Unit Checkpoint",
    time: "30 min",
    status: "Proof Reading",
    createdAt: "2026-04-08",
    questions: 24,
    owner: "My Assessment",
    grade: "Grade 02",
    language: "English",
    subject: "Science",
    term: "Term 2",
    author: "Teacher",
    chapter: "Unit 4",
    difficulty: "Easy",
    examCategory: "Practice Paper",
    source: "Internal",
    createdBy: "Teacher",
    year: "2026",
  },
  {
    id: "english-review-02",
    name: "English Grammar Review",
    time: "25 min",
    status: "Draft",
    createdAt: "2026-03-28",
    questions: 18,
    owner: "My Assessment",
    grade: "Grade 04",
    language: "English",
    subject: "English",
    term: "Term 1",
    author: "Reviewer",
    chapter: "Grammar",
    difficulty: "Hard",
    examCategory: "Review Paper",
    source: "Shared",
    createdBy: "Admin",
    year: "2026",
  },
];

export const sharedAssessments = [
  {
    id: "shared-history-01",
    name: "History Shared Revision Paper",
    time: "50 min",
    status: "Published",
    createdAt: "2026-04-15",
    questions: 40,
    owner: "Shared by Admin",
    grade: "Grade 10",
    language: "English",
    subject: "History",
    term: "Term 1",
    author: "Admin",
    chapter: "Modern History",
    difficulty: "Medium",
    examCategory: "Past Paper",
    source: "Shared",
    createdBy: "Admin",
    year: "2026",
  },
  {
    id: "shared-ict-02",
    name: "ICT Practical Mock Assessment",
    time: "35 min",
    status: "Review",
    createdAt: "2026-04-03",
    questions: 28,
    owner: "Shared by Teacher",
    grade: "Grade 08",
    language: "English",
    subject: "ICT",
    term: "Term 2",
    author: "Teacher",
    chapter: "Practical",
    difficulty: "Hard",
    examCategory: "Mock Exam",
    source: "Shared",
    createdBy: "Teacher",
    year: "2026",
  },
];

const reviewQuestions = [
  {
    id: "paper-q-001",
    title: "gvr",
    allocatedMarks: 2,
    markingGuidance:
      "Read the following passage and choose the synonym for each underlined word from the options given.",
    passage:
      "In recent years, many young people have shown a growing interest in entrepreneurship, seeking opportunities to create their own businesses rather than relying on traditional employment.",
    options: ["btrhrfhbtrtrtrtrtrtr", "gergreg", "gfergerger", "gergerger"],
    correctIndex: 0,
  },
  {
    id: "paper-q-002",
    title: "What is the value of 3 +4?",
    allocatedMarks: 2,
    markingGuidance: "Use the number facts and select the correct value.",
    passage: "",
    options: ["7", "2", "4", "5"],
    correctIndex: 0,
  },
  {
    id: "paper-q-003",
    title: "What is the capital of France?",
    allocatedMarks: 2,
    markingGuidance: "Select the correct city from the options.",
    passage: "",
    options: ["Berlin", "Rome", "Paris", "Madrid"],
    correctIndex: 2,
  },
];

export const sectionItems = {
  questions: [
    {
      id: "ques-001",
      code: "QUSTN87",
      name: "G2-EM-",
      time: "12 questions",
      status: "N/A",
      createdAt: "2026-04-11",
      questions: 12,
      owner: "Category I",
      type: "Descriptive",
      difficulty: "N/A",
      grade: "Grade 02",
      language: "English",
      subject: "English Medium",
      term: "Term 1",
      author: "Admin",
      chapter: "Unit 1",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "ques-002",
      code: "QUSTN81",
      name: "G4-S1-EM-TM1-",
      time: "8 questions",
      status: "Category I",
      createdAt: "2026-04-05",
      questions: 8,
      owner: "Category I",
      type: "Descriptive",
      difficulty: "Hard",
      grade: "Grade 04",
      language: "English",
      subject: "English Medium",
      term: "Term 1",
      author: "Teacher",
      chapter: "Unit 2",
      examCategory: "Practice Paper",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "ques-003",
      code: "QUSTN79",
      name: "G4- Question 2",
      time: "10 questions",
      status: "Category I",
      createdAt: "2026-04-04",
      questions: 10,
      owner: "Category I",
      type: "Descriptive",
      difficulty: "Hard",
      grade: "Grade 04",
      language: "English",
      subject: "Subject I",
      term: "Term 2",
      author: "Teacher",
      chapter: "Chapter 3",
      examCategory: "Model Exam",
      source: "Shared",
      createdBy: "Admin",
      year: "2026",
    },
    {
      id: "ques-004",
      code: "QUSTN78",
      name: "G4- question 1",
      time: "10 questions",
      status: "Category I",
      createdAt: "2026-04-02",
      questions: 10,
      owner: "Category I",
      type: "Descriptive",
      difficulty: "Hard",
      grade: "Grade 04",
      language: "English",
      subject: "Subject I",
      term: "Term 2",
      author: "Reviewer",
      chapter: "Chapter 4",
      examCategory: "Review Paper",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "ques-005",
      code: "QUSTN77",
      name: "G1-",
      time: "6 questions",
      status: "Category I",
      createdAt: "2026-04-01",
      questions: 6,
      owner: "Category I",
      type: "MCQ",
      difficulty: "N/A",
      grade: "Grade 01",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      examCategory: "Mock Exam",
      source: "Internal",
      createdBy: "Admin",
      year: "2026",
    },
    {
      id: "ques-006",
      code: "QUSTN76",
      name: "exdvx",
      time: "6 questions",
      status: "Category I",
      createdAt: "2026-03-30",
      questions: 6,
      owner: "Category I",
      type: "MCQ",
      difficulty: "N/A",
      grade: "Grade 01",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      examCategory: "Mock Exam",
      source: "Shared",
      createdBy: "Teacher",
      year: "2026",
    },
  ],
  allQuestions: [
    {
      id: "ques-001",
      code: "QUSTN87",
      name: "G2-EM-",
      createdAt: "2026-04-11",
      owner: "N/A",
      type: "Descriptive",
      difficulty: "N/A",
      grade: "Grade 02",
      language: "English",
      subject: "English Medium",
      term: "Term 1",
      author: "Admin",
      chapter: "Unit 1",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "ques-002",
      code: "QUSTN81",
      name: "G4-S1-EM-TM1-",
      createdAt: "2026-04-05",
      owner: "Category I",
      type: "Descriptive",
      difficulty: "Hard",
      grade: "Grade 04",
      language: "English",
      subject: "English Medium",
      term: "Term 1",
      author: "Teacher",
      chapter: "Unit 2",
      examCategory: "Practice Paper",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "ques-003",
      code: "QUSTN79",
      name: "G4- Question 2",
      createdAt: "2026-04-04",
      owner: "Category I",
      type: "Descriptive",
      difficulty: "Hard",
      grade: "Grade 04",
      language: "English",
      subject: "Subject I",
      term: "Term 2",
      author: "Teacher",
      chapter: "Chapter 3",
      examCategory: "Model Exam",
      source: "Shared",
      createdBy: "Admin",
      year: "2026",
    },
    {
      id: "ques-004",
      code: "QUSTN78",
      name: "G4- question 1",
      createdAt: "2026-04-02",
      owner: "Category I",
      type: "Descriptive",
      difficulty: "Hard",
      grade: "Grade 04",
      language: "English",
      subject: "Subject I",
      term: "Term 2",
      author: "Reviewer",
      chapter: "Chapter 4",
      examCategory: "Review Paper",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "ques-005",
      code: "QUSTN77",
      name: "G1-",
      createdAt: "2026-04-01",
      owner: "Category I",
      type: "MCQ",
      difficulty: "N/A",
      grade: "Grade 01",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      examCategory: "Mock Exam",
      source: "Internal",
      createdBy: "Admin",
      year: "2026",
    },
    {
      id: "ques-006",
      code: "QUSTN76",
      name: "exdvx",
      createdAt: "2026-03-30",
      owner: "Category I",
      type: "MCQ",
      difficulty: "N/A",
      grade: "Grade 01",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      examCategory: "Mock Exam",
      source: "Shared",
      createdBy: "Teacher",
      year: "2026",
    },
  ],
  reviews: [
    {
      id: "review-001",
      code: "ASMNT99",
      name: "2026.4.6 assessment",
      time: "Due today",
      status: "ProofReading",
      workflowStatus: "InProgress",
      assignedTo: "July JJ",
      commentsCount: 3,
      comments: [
        {
          id: "c-001",
          author: "Reviewer",
          text: "Please confirm the allocated marks before publishing.",
          time: "Today",
        },
        {
          id: "c-002",
          author: "Editor",
          text: "Question 2 needs a clearer marking guidance note.",
          time: "Yesterday",
        },
        {
          id: "c-003",
          author: "Admin",
          text: "Ready for final proof reading after edits.",
          time: "Apr 21",
        },
      ],
      questionsList: reviewQuestions,
      createdAt: "2026-04-14",
      questions: 36,
      owner: "Paper Review",
      grade: "Grade 01",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      difficulty: "Medium",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "July JJ",
      year: "2026",
    },
    {
      id: "review-002",
      code: "ASMNT73",
      name: "Science Paper Final Review",
      time: "Due Apr 24",
      status: "ProofReading",
      workflowStatus: "InProgress",
      assignedTo: "July JJ",
      commentsCount: 1,
      comments: [
        {
          id: "c-004",
          author: "Reviewer",
          text: "Check answer order in MCQ section.",
          time: "Apr 20",
        },
      ],
      questionsList: reviewQuestions,
      createdAt: "2026-04-07",
      questions: 30,
      owner: "Paper Review",
      grade: "Grade 04",
      language: "English",
      subject: "Science",
      term: "Term 2",
      author: "Teacher",
      chapter: "Unit 4",
      difficulty: "Hard",
      examCategory: "Practice Paper",
      source: "Internal",
      createdBy: "July JJ",
      year: "2026",
    },
  ],
  allReviews: [
    {
      id: "review-001",
      code: "ASMNT99",
      name: "2026.4.6 assessment",
      time: "Due today",
      status: "ProofReading",
      workflowStatus: "InProgress",
      assignedTo: "July JJ",
      commentsCount: 3,
      comments: [
        {
          id: "c-001",
          author: "Reviewer",
          text: "Please confirm the allocated marks before publishing.",
          time: "Today",
        },
        {
          id: "c-002",
          author: "Editor",
          text: "Question 2 needs a clearer marking guidance note.",
          time: "Yesterday",
        },
        {
          id: "c-003",
          author: "Admin",
          text: "Ready for final proof reading after edits.",
          time: "Apr 21",
        },
      ],
      questionsList: reviewQuestions,
      createdAt: "2026-04-14",
      questions: 36,
      owner: "My Paper",
      grade: "Grade 01",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      difficulty: "Medium",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "July JJ",
      year: "2026",
    },
    {
      id: "review-002",
      code: "ASMNT73",
      name: "Science Paper Final Review",
      time: "Due Apr 24",
      status: "ProofReading",
      workflowStatus: "InProgress",
      assignedTo: "July JJ",
      commentsCount: 1,
      comments: [
        {
          id: "c-004",
          author: "Reviewer",
          text: "Check answer order in MCQ section.",
          time: "Apr 20",
        },
      ],
      questionsList: reviewQuestions,
      createdAt: "2026-04-07",
      questions: 30,
      owner: "My Paper",
      grade: "Grade 04",
      language: "English",
      subject: "Science",
      term: "Term 2",
      author: "Teacher",
      chapter: "Unit 4",
      difficulty: "Hard",
      examCategory: "Practice Paper",
      source: "Internal",
      createdBy: "July JJ",
      year: "2026",
    },
    {
      id: "review-003",
      code: "ASMNT56",
      name: "English Model Paper Review",
      time: "Due Apr 26",
      status: "Published",
      workflowStatus: "ReviewCompleted",
      assignedTo: "Sarah K",
      commentsCount: 2,
      comments: [
        {
          id: "c-005",
          author: "Reviewer",
          text: "Final language proof completed.",
          time: "Apr 22",
        },
        {
          id: "c-006",
          author: "Editor",
          text: "Ready to move to manage paper.",
          time: "Apr 22",
        },
      ],
      questionsList: reviewQuestions,
      createdAt: "2026-04-16",
      questions: 42,
      owner: "All Papers",
      grade: "Grade 05",
      language: "English",
      subject: "English",
      term: "Term 1",
      author: "Reviewer",
      chapter: "Grammar",
      difficulty: "Easy",
      examCategory: "Model Exam",
      source: "Shared",
      createdBy: "Sarah K",
      year: "2026",
    },
    {
      id: "review-004",
      code: "ASMNT28",
      name: "ICT Practical Paper Review",
      time: "Due Apr 28",
      status: "ProofReading",
      workflowStatus: "InProgress",
      assignedTo: "Nimal P",
      commentsCount: 0,
      comments: [],
      questionsList: reviewQuestions,
      createdAt: "2026-04-01",
      questions: 22,
      owner: "All Papers",
      grade: "Grade 08",
      language: "English",
      subject: "ICT",
      term: "Term 2",
      author: "Teacher",
      chapter: "Practical",
      difficulty: "Medium",
      examCategory: "Mock Exam",
      source: "Internal",
      createdBy: "Nimal P",
      year: "2026",
    },
  ],
  papers: [
    {
      id: "paper-001",
      code: "ASMNT56",
      name: "Test Update Assessment",
      time: "60 min",
      status: "Ready",
      createdAt: "2026-04-10",
      questions: 45,
      owner: "Manage Paper",
      grade: "Grade 10",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 1",
      difficulty: "Medium",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "Admin",
      year: "2026",
      canAdd: true,
    },
    {
      id: "paper-002",
      code: "ASMNT11",
      name: "Test Schedule Assessment",
      time: "40 min",
      status: "Published",
      createdAt: "2026-04-02",
      questions: 26,
      owner: "Manage Paper",
      grade: "Grade 09",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Teacher",
      chapter: "Chapter 2",
      difficulty: "Easy",
      examCategory: "Practice Paper",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "paper-003",
      code: "ASMNT3",
      name: "Test Review Template",
      time: "45 min",
      status: "Ready",
      createdAt: "2026-03-29",
      questions: 30,
      owner: "Manage Paper",
      grade: "Grade 08",
      language: "English",
      subject: "Science",
      term: "Term 2",
      author: "Reviewer",
      chapter: "Unit 3",
      difficulty: "Medium",
      examCategory: "Review Paper",
      source: "Shared",
      createdBy: "Reviewer",
      year: "2026",
    },
    {
      id: "paper-004",
      code: "ASMNT19",
      name: "test new",
      time: "35 min",
      status: "Ready",
      createdAt: "2026-03-25",
      questions: 22,
      owner: "Manage Paper",
      grade: "Grade 07",
      language: "English",
      subject: "ICT",
      term: "Term 2",
      author: "Admin",
      chapter: "Practical",
      difficulty: "Hard",
      examCategory: "Mock Exam",
      source: "Internal",
      createdBy: "Admin",
      year: "2026",
    },
    {
      id: "paper-005",
      code: "ASMNT17",
      name: "testingSahan",
      time: "55 min",
      status: "Published",
      createdAt: "2026-03-18",
      questions: 34,
      owner: "Manage Paper",
      grade: "Grade 10",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Teacher",
      chapter: "Chapter 4",
      difficulty: "Medium",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "paper-006",
      code: "ASMNT16",
      name: "testingDum",
      time: "55 min",
      status: "Published",
      secondaryStatus: "Added",
      createdAt: "2026-03-14",
      questions: 34,
      owner: "Manage Paper",
      grade: "Grade 10",
      language: "English",
      subject: "Subject I",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 4",
      difficulty: "Medium",
      examCategory: "Model Exam",
      source: "Internal",
      createdBy: "Admin",
      year: "2026",
      canManage: true,
    },
    {
      id: "paper-007",
      code: "ASMNT53",
      name: "Tamil paper",
      time: "45 min",
      status: "Published",
      createdAt: "2026-03-10",
      questions: 28,
      owner: "Manage Paper",
      grade: "Grade 06",
      language: "Tamil",
      subject: "Tamil",
      term: "Term 1",
      author: "Teacher",
      chapter: "Chapter 2",
      difficulty: "Easy",
      examCategory: "Practice Paper",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
      canAdd: true,
    },
    {
      id: "paper-008",
      code: "ASMNT44",
      name: "Tamil grade 10",
      time: "50 min",
      status: "Published",
      secondaryStatus: "Added",
      createdAt: "2026-03-08",
      questions: 31,
      owner: "Manage Paper",
      grade: "Grade 10",
      language: "Tamil",
      subject: "Tamil",
      term: "Term 1",
      author: "Admin",
      chapter: "Chapter 5",
      difficulty: "Medium",
      examCategory: "Model Exam",
      source: "Shared",
      createdBy: "Admin",
      year: "2026",
      canManage: true,
    },
    {
      id: "paper-009",
      code: "ASMNT23",
      name: "sdsd",
      time: "30 min",
      status: "Published",
      createdAt: "2026-03-05",
      questions: 24,
      owner: "Manage Paper",
      grade: "Grade 05",
      language: "English",
      subject: "Science",
      term: "Term 2",
      author: "Teacher",
      chapter: "Unit 1",
      difficulty: "Easy",
      examCategory: "Mock Exam",
      source: "Internal",
      createdBy: "Teacher",
      year: "2026",
    },
    {
      id: "paper-010",
      code: "ASMNT46",
      name: "Science grade 10",
      time: "55 min",
      status: "Published",
      secondaryStatus: "Added",
      createdAt: "2026-03-02",
      questions: 37,
      owner: "Manage Paper",
      grade: "Grade 10",
      language: "English",
      subject: "Science",
      term: "Term 2",
      author: "Reviewer",
      chapter: "Unit 4",
      difficulty: "Hard",
      examCategory: "Model Exam",
      source: "Shared",
      createdBy: "Reviewer",
      year: "2026",
      canManage: true,
    },
  ],
  exams: [
    {
      id: "exam-001",
      name: "New English",
      time: "Unlimited",
      attempt: "1 out of 1",
      durationMinutes: 0,
      status: "Published",
      createdAt: "2026-04-16",
      questions: 50,
      owner: "Exam",
      grade: "Grade 06",
      language: "English",
      subject: "English",
      examCategory: "Model Exam",
      action: "start",
      report: {
        percentage: "85%",
        grade: "A",
        studentName: "AKSHAY SYAL",
        marks: "435 / 500",
        attemptNumber: "1",
        paperDuration: "Unlimited",
        attemptedDate: "2026-04-16",
      },
    },
    {
      id: "exam-002",
      name: "New English",
      time: "Unlimited",
      attempt: "1 out of 1",
      durationMinutes: 0,
      status: "Scheduled",
      createdAt: "2026-04-09",
      questions: 20,
      owner: "Exam",
      grade: "Grade 06",
      language: "English",
      subject: "English",
      examCategory: "Practice Paper",
      action: "start",
      report: {
        percentage: "78%",
        grade: "B",
        studentName: "AKSHAY SYAL",
        marks: "390 / 500",
        attemptNumber: "1",
        paperDuration: "Unlimited",
        attemptedDate: "2026-04-09",
      },
    },
    {
      id: "exam-003",
      name: "New English",
      time: "Unlimited",
      attempt: "1 out of 1",
      durationMinutes: 0,
      status: "Scheduled",
      createdAt: "2026-04-05",
      questions: 20,
      owner: "Exam",
      grade: "Grade 07",
      language: "English",
      subject: "Science",
      examCategory: "Model Exam",
      action: "start",
      report: {
        percentage: "82%",
        grade: "A",
        studentName: "AKSHAY SYAL",
        marks: "410 / 500",
        attemptNumber: "1",
        paperDuration: "Unlimited",
        attemptedDate: "2026-04-05",
      },
    },
    {
      id: "exam-004",
      name: "New English",
      time: "Unlimited",
      attempt: "1 out of 1",
      durationMinutes: 0,
      status: "Scheduled",
      createdAt: "2026-04-03",
      questions: 20,
      owner: "Exam",
      grade: "Grade 07",
      language: "English",
      subject: "Math",
      examCategory: "Mock Exam",
      action: "resume",
      report: {
        percentage: "74%",
        grade: "B",
        studentName: "AKSHAY SYAL",
        marks: "370 / 500",
        attemptNumber: "1",
        paperDuration: "Unlimited",
        attemptedDate: "2026-04-03",
      },
    },
    {
      id: "exam-005",
      name: "New English",
      time: "Unlimited",
      attempt: "1 out of 1",
      durationMinutes: 0,
      status: "Scheduled",
      createdAt: "2026-04-01",
      questions: 20,
      owner: "Exam",
      grade: "Grade 08",
      language: "English",
      subject: "Computer",
      examCategory: "Practice Paper",
      action: "grade-report",
      report: {
        percentage: "85%",
        grade: "A",
        studentName: "AKSHAY SYAL",
        marks: "425 / 500",
        attemptNumber: "1",
        paperDuration: "Unlimited",
        attemptedDate: "2026-04-01",
      },
    },
  ],
};
